import React from 'react'
import { Avatar } from '@chakra-ui/react'
import { Text, Center } from '@chakra-ui/react'

import { getUserFullName } from '~utils/helpers'
import SharedStack from '~components/shared/wrappers/shared-stack'
import { InternalChatUserPreviewFieldsFragment } from '~graphql/generated/graphql'

export function InternalChatUsersPreview({
    users,
}: {
    users: InternalChatUserPreviewFieldsFragment[]
}) {
    const usersToShow = users.slice(0, 3)
    const remainingCount = users.length - usersToShow.length
    const remainingText = remainingCount > 0 ? `+${remainingCount}` : ''

    if (usersToShow.length === 0) return null

    return (
        <SharedStack row fit spacing={1}>
            {usersToShow.map((user, idx) => (
                <InternalChatUserAvatar key={user.id} user={user} />
            ))}
            {remainingText && (
                <Center
                    w="24px"
                    h="24px"
                    bg="gray.300"
                    rounded="md"
                    position="relative"
                >
                    <Text
                        fontSize="11px"
                        color="gray.700"
                        fontWeight="semibold"
                    >
                        {remainingText}
                    </Text>
                </Center>
            )}
        </SharedStack>
    )
}

export function InternalChatUserAvatar({
    user,
}: {
    user?: InternalChatUserPreviewFieldsFragment
}) {
    return (
        <Avatar
            key={`${user?.user.id}-${user?.user.avatar_url}-${user?.user.first_name}-${user?.user.last_name}`}
            size="xs"
            borderRadius="md"
            src={user?.user.avatar_url || ''}
            name={user?.user ? getUserFullName(user.user) : ''}
        />
    )
}
